




























































import {Vue, Component, VModel} from 'vue-property-decorator';
import RightSideBar from "@/components/payroll/business/services/RightSideBar.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import ServiceView from "@/components/payroll/business/services/ServiceView.vue";
import ServiceItem from "@/components/payroll/business/services/ServiceItem.vue";
import Application from "@/state/Application";
import ServiceLogOrchestrator from "@/services/ServiceLogOrchestrator";
import {
	AddressLocationOption,
	BranchLocationOption, LocationOption,
	ProjectLocationOption
} from "@/components/payroll/business/services/ServiceDTO";
import {ifValid, processError} from "@/utils/ComponentUtils";
import PortalSelect from "@/components/common/PortalSelect.vue";
import SelectOption from "@/components/common/SelectOption";
import AddressDTO from "@/dto/AddressDTO";

@Component({
	computed: {
		SelectOption() {
			return SelectOption
		}
	},
	components: {PortalSelect, ServiceItem, ServiceView, PortalInput, RightSideBar}
})
export default class LocationSliderSelector extends Vue {

	@VModel({type: Boolean, default: false})
	private model!: boolean

	private address: AddressDTO = new AddressDTO()

	private save() {
		ifValid(this, () => {
			Application.startLoading()
			ServiceLogOrchestrator.createLocation(this.address).then(
				res => {
					Application.stopLoading()
					this.$emit('created', new AddressLocationOption(res.data))
					this.$emit("input", false);
				},
				err => processError(err, this)
			)
		})
	}


}
